import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-bg" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "spinner",
    viewBox: "0 0 50 50"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      "stroke-width": "5"
    })
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['spinner-container min-vh-100 w-100', {'absolute': _ctx.isAbsolute, 'flex-centered py-5': !_ctx.isAbsolute}])
      }, _hoisted_2, 2))
    : _createCommentVNode("", true)
}